module.exports = __webpack_public_path__ + "static/img/bk_friend.8723726a.jpg";